var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlinkedExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.375 1.08594L1.63281 0.539062L0.5 1.98438L1.24219 2.57031L23.5859 19.9531L24.3281 20.5L25.4609 19.0156L24.7188 18.4688L22.9609 17.1016C24.4844 16.0859 25.5 14.3672 25.5 12.375C25.5 9.28906 22.9609 6.75 19.875 6.75H19.25V9.25H19.875C21.5938 9.25 23 10.6562 23 12.375C23 13.7812 22.0625 14.9922 20.7734 15.3828L16.7109 12.2188C17.4922 11.2422 18 9.99219 18 8.625C18 5.53906 15.4609 3 12.375 3H6.125C5.73438 3 5.34375 3.03906 4.99219 3.11719L2.375 1.08594ZM8.07812 5.5H12.375C14.0938 5.5 15.5 6.90625 15.5 8.625C15.5 9.40625 15.1875 10.1484 14.7188 10.6953L8.07812 5.5ZM17.9219 18L14.7578 15.5H13.625C11.8672 15.5 10.5 14.1328 10.5 12.375C10.5 12.2969 10.5 12.2188 10.5 12.1406L8.3125 10.4609C8.11719 11.0469 8 11.7109 8 12.4141C8 15.5 10.5 18.0391 13.625 18.0391H17.9219V18ZM1.67188 5.1875C0.929688 6.16406 0.5 7.33594 0.5 8.625C0.5 11.75 3 14.25 6.125 14.25H6.75V11.75H6.125C4.36719 11.75 3 10.3828 3 8.625C3 7.92188 3.23438 7.25781 3.625 6.75L1.67188 5.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkedExpenses);
export default __webpack_public_path__ + "static/media/unlinked_expenses.d8d97a494de9518df14727f5da5051bf.svg";
export { ForwardRef as ReactComponent };